var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcChooseCardIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.09 0.312744C33.4036 0.312744 36.0899 2.99879 36.09 6.31274V10.0627H27.8907C24.8791 10.0628 22.4376 12.504 22.4376 15.5159V17.1145C22.4376 20.1261 24.8791 22.5676 27.8907 22.5676H36.09V26.3889C36.0898 29.7024 33.4036 32.3889 30.09 32.3889H6.80676C3.49315 32.3889 0.80691 29.7024 0.806763 26.3889V6.31274C0.806817 2.99879 3.4931 0.312744 6.80676 0.312744H30.09ZM7.8634 10.5774H20.6935V7.36938H7.8634V10.5774Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0904 13.1428H29.0337C27.2622 13.1428 25.8261 14.5792 25.8261 16.3509C25.8261 18.1225 27.2622 19.5583 29.0337 19.5583H36.0904V13.1428Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6752 14.4929C30.7012 14.4929 31.5329 15.3242 31.5329 16.3508C31.5329 17.3766 30.7012 18.208 29.6752 18.208C28.6492 18.208 27.8174 17.3766 27.8174 16.3508C27.8174 15.3242 28.6492 14.4929 29.6752 14.4929Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcChooseCardIcon2);
export default __webpack_public_path__ + "static/media/xdc-choose-card-icon-2.aaec7208412217af5c817aee25199f94.svg";
export { ForwardRef as ReactComponent };